import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { matchRoutes } from "react-router";

export const useGetLocationParams = () => {
  const location = useLocation();
  return useMemo(() => {
    const routes = [
      { path: "/:customerId/*" },
      { path: "/:customerId/admin/:sport/*" },
      { path: "/:customerId/admin/:sport/:organizationId/*" },
      { path: "/:customerId/admin/:sport/:organizationId/seasons/:seasonId/*" },
    ];

    const match = matchRoutes(routes, location);
    
    return match?.[0]?.params || {};
  }, [location.pathname]);
}
